import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface NotificationHtmlModalProps {
  title: string;
  htmlContent: string;
  onClose: () => void;
}

export const NotificationHtmlModal: React.FC<NotificationHtmlModalProps> = ({
  title,
  htmlContent,
  onClose,
}) => (
  <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50">
    <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900 truncate pr-4">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="p-2 rounded-lg text-gray-500 hover:bg-gray-100"
          aria-label="Đóng"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
      <iframe
        title={title}
        srcDoc={htmlContent}
        className="flex-1 w-full min-h-[60vh] border-0"
        sandbox="allow-same-origin"
      />
    </div>
  </div>
);

interface NotificationTextModalProps {
  title: string;
  message: string;
  onClose: () => void;
}

export const NotificationTextModal: React.FC<NotificationTextModalProps> = ({
  title,
  message,
  onClose,
}) => (
  <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50">
    <div className="bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[85vh] flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900 truncate pr-4">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="p-2 rounded-lg text-gray-500 hover:bg-gray-100"
          aria-label="Đóng"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
      <div className="p-4 overflow-auto whitespace-pre-wrap text-sm text-gray-700">{message}</div>
      <div className="px-4 py-3 border-t border-gray-100 flex justify-end">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
        >
          Đóng
        </button>
      </div>
    </div>
  </div>
);

export type NotificationOverlay =
  | { kind: 'html'; title: string; htmlContent: string }
  | { kind: 'text'; title: string; message: string };

interface NotificationOverlayHostProps {
  overlay: NotificationOverlay | null;
  onClose: () => void;
}

export const NotificationOverlayHost: React.FC<NotificationOverlayHostProps> = ({
  overlay,
  onClose,
}) => {
  if (!overlay) return null;
  if (overlay.kind === 'html') {
    return (
      <NotificationHtmlModal
        title={overlay.title}
        htmlContent={overlay.htmlContent}
        onClose={onClose}
      />
    );
  }
  return (
    <NotificationTextModal title={overlay.title} message={overlay.message} onClose={onClose} />
  );
};
